module.exports = __webpack_public_path__ + "img/coin-network.740c0867.png";